module.exports = __webpack_public_path__ + "img/tertiaire.f146bf3e.jpg";